import { Link } from "react-router-dom";
import type { Episode } from "@/mocks/episodes";
import { formatDate } from "@/lib/content";

type EpisodeCardProps = {
  episode: Episode;
};

export default function EpisodeCard({ episode }: EpisodeCardProps) {
  return (
    <Link
      to={`/detail/${episode.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-accent-300 transition-all duration-300 cursor-pointer h-full flex flex-col"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-foreground-900">
        <img
          src={episode.cover}
          alt={`${episode.title} 剧情剧照`}
          title={`${episode.title} - ${episode.subtitle}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-medium whitespace-nowrap">
          {episode.type}
        </span>
        <span className="absolute bottom-3 left-3 font-label text-xs text-background-50 tracking-wide">
          <i className="ri-play-circle-line mr-1"></i>
          EP.{String(episode.episodeNo).padStart(2, "0")}
        </span>
      </div>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {episode.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 flex-1">
          {episode.summary}
        </p>
        <div className="mt-4 pt-3 border-t border-background-200/80 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line"></i>
            {formatDate(episode.date)}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line"></i>
            {episode.duration}
          </span>
        </div>
      </div>
    </Link>
  );
}